import { BasemapProviderEnum } from '@gishub/domain';
import { IBasemapSourceStrategy } from '../strategies/i-basemap-source-strategy';
import { RasterBasemapStrategy } from '../strategies/raster-basemap-strategy';
import { VectorBasemapStrategy } from '../strategies/vector-basemap-strategy';

export class BasemapStrategyFactory {
  private static readonly RASTER = new RasterBasemapStrategy();
  private static readonly VECTOR = new VectorBasemapStrategy();

  private static readonly OVERRIDES: Partial<Record<BasemapProviderEnum, IBasemapSourceStrategy>> = {};

  static registerOverride(provider: BasemapProviderEnum, strategy: IBasemapSourceStrategy): void {
    this.OVERRIDES[provider] = strategy;
  }

  static getStrategy(type: 'raster' | 'vector', _provider: BasemapProviderEnum): IBasemapSourceStrategy {
    const overridden = this.OVERRIDES[_provider];
    if (overridden) return overridden;
    return type === 'vector' ? this.VECTOR : this.RASTER;
  }
}
